// components/problems/difficulty-cell.tsx
import { cn } from '@/lib/utils'

interface DifficultyCellProps {
  difficulty: { name: string } | null
}

export function DifficultyCell({ difficulty }: DifficultyCellProps) {
  if (!difficulty) return null

  const label = difficulty.name === 'Medium' ? 'Med.' : difficulty.name
  const colorClass =
    difficulty.name === 'Easy'
      ? 'text-green-500'
      : difficulty.name === 'Medium'
        ? 'text-yellow-500'
        : 'text-red-500'

  return (
    <div className="flex items-center justify-end">
      <span className={cn(colorClass, 'text-sm')}>{label}</span>
    </div>
  )
}
